import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';

import Dashboard from './pages/Dashboard';
import Scanner from './pages/Scanner';
import Settings from './pages/Settings';
import SymbolRecommendations from './pages/SymbolRecommendations';
import ScanResult from './pages/ScanResult';
import Admin from './pages/Admin';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import AuthError from './pages/AuthError';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuthStore } from './store/authStore';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

function App() {
  const { isAuthenticated, checkAuth } = useAuthStore();

  React.useEffect(() => { checkAuth(); }, [checkAuth]);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/success" element={<AuthCallback />} />
            <Route path="/auth/error" element={<AuthError />} />

            {[
              { path: '/', element: <Dashboard /> },
              { path: '/scanner', element: <Scanner /> },
              { path: '/settings', element: <Settings /> },
              { path: '/scan-result/:id', element: <ScanResult /> },
              { path: '/recommendations', element: <SymbolRecommendations /> },
              { path: '/admin', element: <Admin /> },
            ].map(({ path, element }) => (
              <Route key={path} path={path} element={
                <ProtectedRoute><Layout>{element}</Layout></ProtectedRoute>
              } />
            ))}

            <Route path="*" element={isAuthenticated ? <Navigate to="/" replace /> : <Navigate to="/login" replace />} />
          </Routes>

          <Toaster position="top-right" toastOptions={{
            duration: 4000,
            style: { background: '#363636', color: '#fff' },
          }} />
        </Router>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
